<template>
    <div id="footer" class="grid-container">
        <div class="grid-item">
            <h3 class="section-title">
                General<br/>-
            </h3>

            <p>
                <span>hello@naptics.ch</span>
                <br/>
                <span style="white-space: nowrap;">Fabian: +41 79 423 22 43</span>
                <br/>
                <span>Jonas: +41 79 226 42 28</span>
            </p>
        </div>
        <div class="grid-item">
            <h3 class="section-title">
                Office<br/>-
            </h3>
            <p>
                <span>naptics GmbH</span>
                <br/>
                <span>Technoparkstrasse 2</span>
                <br/>
                <span>CH-8406 Winterthur</span>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PageFooter'
    }
</script>

<style lang="scss" scoped>
    @import "../styles/main";

    .grid-item {
        text-align: center;
    }

    .section-title {
        color: #ff5519;
    }

    #footer {
        background: #252525;
        color: #FFFFFF;
        font-family: "PxGrotesk-Regular", sans-serif;
        font-size: 15px;
        line-height: 1.4em;
    }
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue